import type { IconSvgProps } from '../iconProps';

const PdfIcon = ({ theme: _theme, ...props }: IconSvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Document base */}
    <path
      d="M6.75 22H21.25C21.3875 22 21.5 21.8875 21.5 21.75V7H17.25C16.8365 7 16.5 6.6635 16.5 6.25V2H6.75C6.6125 2 6.5 2.1125 6.5 2.25V21.75C6.5 21.8875 6.6125 22 6.75 22Z"
      fill="white"
    />
    {/* Document fold */}
    <path
      d="M21.1465 6.50002L17 2.35352V6.25002C17 6.38752 17.1125 6.50002 17.25 6.50002H21.1465Z"
      fill="white"
    />
    {/* Document border - now red */}
    <path
      opacity="0.64"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.78 6.427L17.073 1.7195C16.9321 1.57945 16.7417 1.50059 16.543 1.5H6.75C6.3365 1.5 6 1.8365 6 2.25V21.75C6 22.1635 6.3365 22.5 6.75 22.5H21.25C21.6635 22.5 22 22.1635 22 21.75V6.957C22 6.757 21.922 6.5685 21.78 6.427ZM17 2.3535L21.1465 6.5H17.25C17.1837 6.49987 17.1202 6.47349 17.0734 6.42663C17.0265 6.37978 17.0001 6.31626 17 6.25V2.3535ZM6.75 22H21.25C21.3875 22 21.5 21.8875 21.5 21.75V7H17.25C16.8365 7 16.5 6.6635 16.5 6.25V2H6.75C6.6125 2 6.5 2.1125 6.5 2.25V21.75C6.5 21.8163 6.52634 21.8799 6.57322 21.9268C6.62011 21.9737 6.6837 22 6.75 22Z"
      fill="#FF4444"
    />
    {/* PDF logo area - red rectangle in bottom left */}
    <path
      d="M3 18.5H12C12.2652 18.5 12.5196 18.3946 12.7071 18.2071C12.8946 18.0196 13 17.7652 13 17.5V8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5H3C2.73478 7.5 2.48043 7.60536 2.29289 7.79289C2.10536 7.98043 2 8.23478 2 8.5V17.5C2 17.7652 2.10536 18.0196 2.29289 18.2071C2.48043 18.3946 2.73478 18.5 3 18.5Z"
      fill="#FF4444"
    />
    {/* PDF text on logo - larger and better positioned */}
    <text
      x="7.5"
      y="14"
      fontSize="6"
      fill="white"
      textAnchor="middle"
      dominantBaseline="middle"
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
    >
      PDF
    </text>
  </svg>
);

export default PdfIcon;
